// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"132aed09","498":"4e4d319b","703":"bb5090de"}[chunkId] + ".chunk.js";
};